import { render, staticRenderFns } from "./akcd_rmAkcc.vue?vue&type=template&id=2ac0f8e0"
import script from "./akcd_rmAkcc.vue?vue&type=script&lang=js"
export * from "./akcd_rmAkcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports